import styled from 'styled-components';

export const ChartWrapper = styled.div`
  width: 100%;
  height: 400px;
  position: relative;

  canvas {
    width: 100% !important;
    height: 400px !important;
  }
`;
